const seasons = [
    {
        id: 23,
        name: 'Omen of Storms',
        abbr: 'OoS',
        start: 1640620800000,
        end: 1648137599999
    },
    {
        id: 24,
        name: 'Edge of Paradise',
        abbr: 'EoP',
        start: 1648137600000,
        end: 1656394199999,
    }
]

export default seasons